module.exports = __webpack_public_path__ + "img/lucky(2).2449f83b.png";